import React from 'react'
import BanksListTable from '../../components/Fundraiser/BanksList';

const BanksList = () => {
  return (
    <BanksListTable />
  )
}

export default BanksList;